// extracted by mini-css-extract-plugin
export default {"link":"lL-z","disabled":"mL-z"};